<template>
<v-dialog v-model="show" scrollable>
  <template v-slot:activator="{on}">
     <slot name="activator" :on="on"></slot>
  </template>
  <v-card>
    <CardTitle :title="'Create Order' + (!manifest ? '' : ' From Manifest')">
      <template v-slot:actions>
        <v-btn @click="show = false" icon><v-icon>close</v-icon></v-btn>
      </template>1
    </CardTitle>
    <v-card-text class="pa-0" v-if="show">
      <v-stepper v-model="currentStep" flat>
        <v-stepper-header>
          <v-stepper-step step="1" v-if="manifest" :complete="manifest.manifest_data.status === 'received'" :disabled="!manifest" editable>
            Verify Sample Presence
          </v-stepper-step>
          <v-stepper-step step="2" :editable="!manifest || manifest.manifest_data.status === 'received'">
            Sample Setup
          </v-stepper-step>
          <v-stepper-step step="3">
            Print Sample Ids
          </v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1" >
            <StepVerifyPresence v-if="manifest" @next="currentStep+=1" @received_manifest="updateManifest($event)" :manifest_items="manifest.manifest_data.inventory_transfer_items" :manifest_id="manifest.manifest_data.global_id" :received="manifest.manifest_data.status === 'received'"></StepVerifyPresence>
          </v-stepper-content>
          <v-stepper-content step="2">
            <StepSampleCreate
                ref="sample_create"
                @next="next(3, $event)"
                :manifest="(receivedManifest||!manifest) ? receivedManifest : manifest.manifest_data"
                :received="(receivedManifest||!manifest) ? true : manifest.manifest_data.status === 'received'"
                :preloaded_manifest="preloaded_manifest"
            >

            </StepSampleCreate>
          </v-stepper-content>
          <v-stepper-content step="3">
            <StepPrintLabels  ref="print_labels" :has_manifest="!!manifest" @reset="reset" @next="show = false"></StepPrintLabels>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card-text>
  </v-card>
</v-dialog>
</template>

<script>
export default {
    name: "CreateFromManifest",
    components: {
      StepVerifyPresence: () => import("@/views/orders/components/Manifest/StepVerifyPresence"),
      StepSampleCreate: () => import("@/views/orders/components/Manifest/StepSampleCreate"),
      StepPrintLabels: () => import("@/views/orders/components/Manifest/StepPrintLabels")
    },
    props:{
      manifest:{
        required: false,
      },
      preloaded_manifest:{
        required: false,
      }
    },
    mounted(){
      if(!this.manifest){
        this.currentStep=2;
      }

    },
    data: () => ({
      currentStep: 1,
      show: false,
      receivedManifest: null,
    }),
    methods: {
      updateManifest(data){
        this.receivedManifest = data;
        this.$firestore.collection('manifests').doc(this.manifest.uid).update({manifest_data: data});
        this.next(2);
      },
      next(nextStep, data = null){
        this.currentStep = nextStep;
        if(nextStep.toString() === '3' && data){
          this.$emit("sample_submit")

          this.$refs.print_labels.setSamples(data)
        }
      },
      reset(){
        this.currentStep = 2;
        this.$nextTick(() => {
          this.$refs.sample_create.mapIntegratorManifest();
          this.$refs.sample_create.ccrsManifestId= null;
        })
      }
    }
}
</script>

<style scoped>

</style>
